import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnChanges {
  @Input() isActive: boolean;
  @Input() isLarge = false;
  @Input() isFull = false;
  @Input() isSmall = false;
  @Input() showCloseFooter = true;
  @Input() showAcceptFooter = false;
  @Input() acceptFooterDisabled = false;
  @Input() showClose = true;
  @Input() enableFooter = true;
  @Input() padding = true;
  @Input() zIndex = 40;
  @Input() closeOnEsc = true;

  @Output() modalState = new EventEmitter<boolean>();
  @Output() acceptState = new EventEmitter<boolean>();
  @Output() onPressEsc = new EventEmitter<boolean>();

  @ViewChild('modal') modal: ElementRef;

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.isActive?.currentValue === true && this.showClose) {
      setTimeout(() => {
        this.modal.nativeElement.focus();
      }, 1);
    }
  }

  modalInteration() {
    this.modalState.emit(!this.isActive);
  }

  onPressEscKey() {
    if (this.closeOnEsc) {
      this.modalState.emit(!this.isActive);
    } else {
      this.onPressEsc.emit(true);
    }
  }

  sendAccept() {
    this.acceptState.emit(true);
  }
}
